export default {
  landingCta: {
    id: 'product_reviews_block_button_v2',
    defaultMessage: 'See all { count } reviews',
  },
  filterByStars: {
    id: 'product_reviews_block_filter_by_stars',
    defaultMessage: 'Filter by stars',
  },
  rateDescription: {
    id: 'review_display_rate_description',
    defaultMessage: `{totalReviews, number} {totalReviews, plural,
      one {purchase}
      other {purchases}
    } in the last 6 months.`,
  },
  title: {
    id: 'product_reviews_block_bottom_title',
    defaultMessage: "{ title }'s customer reviews",
  },
  all: {
    id: 'product_reviews_block_all',
    defaultMessage: 'All',
  },
  fourFive: {
    id: 'product_reviews_block_between_4_and_5',
    defaultMessage: '4-5',
  },
  threeFour: {
    id: 'product_reviews_block_between_3_and_4',
    defaultMessage: '3-4',
  },
  twoThree: {
    id: 'product_reviews_block_between_2_and_3',
    defaultMessage: '2-3',
  },
  oneTwo: {
    id: 'product_reviews_block_between_1_and_2',
    defaultMessage: '1-2',
  },
  percentage: {
    id: 'product_reviews_block_percentage',
    defaultMessage: '{ percentage }%',
  },
}
